export default __webpack_public_path__ + "static/logo-white-413896c9159c268d054f5071108f9816.svg";